module.exports = __webpack_public_path__ + "static/DSC_4298-a38120c7b554b7a039ff71baf7785b65.png";